import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { get, signPost } from '../../common/fetch';

import {
    View,
    StyleSheet
} from 'react-native';

import {
    JDImage,
    JDText,
    JDTouchable,
    JDJumping
} from '@jdreact/jdreact-core-lib';

import Stars from '../stars';
import { pt, getByteLen, clip } from '../../common/utils';
import sgmReport from '../../common/sgmUtil';

class EvaluationItem extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            movieEvaluate: [],
            introMoreShow: false
        };
    }

    render() {
        const { movieEvaluate } = this.state;

        return (
            <View style={ { flex: 1, marginTop: pt(1), backgroundColor: '#fff', paddingTop: pt(15) } }>
                <JDText style={ st.evaluate_tittle }>影片热评</JDText>

                {
                    movieEvaluate.map((val, index) => {
                        return (
                            <View key={ index } style={ { flexDirection: 'row' } }>
                                <View style={ { width: pt(52), paddingLeft: pt(15) } }>
                                    <JDImage source={ { uri: val.userImageUrl } } style={ st.evaluate_hpic } />
                                </View>
                                <View style={ { marginRight: pt(16), flex: 1 } }>
                                    <JDText style={ st.evaluate_name }>{val.nickname}</JDText>
                                    <JDText style={ st.evaluate_date }>{val.creationTime}</JDText>
                                    <Stars score={ val.score * 2 } style={ {} } size={ 12 } color='oriange' />
                                    <View>
                                        <Content val={ val } />
                                    </View>
                                </View>
                            </View>
                        );
                    })
                }

                <JDTouchable activeOpacity={ 0.5 } onPress={ this.goMovieEvaluation }>
                    <View style={ st.btn_body }>
                        <View style={ st.btn_content }>
                            <JDText style={ st.btn_rel }>查看更多评论</JDText>
                        </View>
                    </View>
                </JDTouchable>
            </View>

        );
    }

    componentDidMount() {
        const { info } = this.props;
        
        signPost('movieCommentList', { skuId: info.jSkuId, page: 1, pageSize: 2 }).then(res => {
            if (res.data.errCode == 1000) {
                this.props.hide(false);
            }
            this.setState({ movieEvaluate: res.data });

            if(res.data && res.data.length){
                const hasEmpty = res.data.some(item =>  !item.userImageUrl);
                if(hasEmpty){
                    sgmReport('1002', {function_id: 'movieCommentList',message:'返回数据缺少图片地址'}, 3)
                }
                
            }
        }).catch(() => {
            this.props.hide(false);
        });

        if(!info.jSkuId){
            sgmReport('1001', {function_id: 'movieCommentList',message:'缺少参数skuId'}, 3)
        }
    }

    toggleIntroMore = () => {
        this.setState({
            introMoreShow: !this.state.introMoreShow
        });
    }

      /* 跳转到影片评价页 */
      goMovieEvaluation = () => {
          const { info } = this.props;

          const url = 'https://apollo-evaluate.jd.com/?jdreactkey=JDReactEvaluateModule&jdreactapp=JDReactEvaluateModule&key=value&page=EvaluateListWrapper&sku=' + info.jSkuId + '&category=274938;12420;12422&isCurrentSku=false&showSkuChange=true';

          JDJumping.jumpToWeb(url).catch(err => alert(err));
      }
}

class Content extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            introMoreShow: false
        };
    }

    render() {
        const { val } = this.props;

        const { introMoreShow } = this.state;

        return (
            <JDText style={ st.evaluate_content } onPress={ this.toggleIntroMore }>
                {(getByteLen(val.content) > 210 && !introMoreShow) ? clip(val.content, 210) + '... ' : val.content}
                {!!(getByteLen(val.content) > 210) && <JDText style={ { color: '#2B84FF' } } >{!introMoreShow ? '展开' : '收起'}</JDText>}
            </JDText>
        );
    }

    toggleIntroMore = () => {
        this.setState({
            introMoreShow: !this.state.introMoreShow
        });
    }
}

const st = StyleSheet.create({
    evaluate_tittle: {
        color: '#252525',
        paddingLeft: pt(16),
        paddingBottom: pt(10),
        fontWeight: 'bold',
        // paddingTop:pt(20),
        lineHeight: pt(24),
        fontFamily: 'PingFangSC-Regular',
        fontSize: pt(14)
    },
    evaluate_name: {
        color: '#252525',
        paddingTop: pt(0),
        fontFamily: 'PingFangSC-Regular',
        fontSize: pt(12),
        marginBottom: pt(5)
    },
    evaluate_date: {
        position: 'absolute',
        right: pt(0),
        top: pt(2),
        color: 'rgb(132,132,132)',
        fontSize: pt(10)
    },
    evaluate_content: {
        color: '#252525',
        paddingTop: pt(5),
        // marginRight:pt(15),
        paddingBottom: pt(10),
        fontFamily: 'PingFangSC-Regular',
        fontSize: pt(12),
        lineHeight: pt(18)
    },
    evaluate_hpic: {
        height: pt(30),
        width: pt(30),
        borderRadius: pt(20),
        resizeMode: 'contain',
        paddingLeft: pt(10)
    },
    btn_body: {
        alignItems: 'center',
        paddingBottom: pt(20),
        backgroundColor: '#fff'
    },
    btn_content: {
        borderRadius: pt(6),
        width: pt(132),
        height: pt(31),
        borderColor: 'rgba(225,225,225,1)',
        borderStyle: 'solid',
        borderWidth: pt(1),
        justifyContent: 'center',
        alignItems: 'center'
    },
    btn_rel: {
        fontSize: pt(12),
        justifyContent: 'center',
        alignItems: 'center',
        fontWeight: 'bold'
    }
});

export default EvaluationItem;
